module.exports = __webpack_public_path__ + "static/media/RP-90.db60d07a.pdf";